import { memo, useRef, useEffect, useState } from 'react';
import { AutoComplete } from 'antd';
import classNames from 'classnames';
import LoadingIcon from '../../../assets/search-loader-brac-v1-01.gif';
import './style.scss';
import { Translate } from '../index';

interface Option {
  value: string;
  label: React.ReactNode;
}

interface Category {
  label: React.ReactNode;
  options: Option[];
}

interface SearchProps {
  width?: number;
  classname?: string;
  styles?: React.CSSProperties;
  onSearch?: (value: string) => void;
  placeholder?: string | React.ReactNode;
  options: Category[];
  onSelect?: (value: any) => void;
  loading?: boolean;
  foundContent?: boolean;
  value?: string;
  listHeight?: number;
}

export function Search({
  onSelect,
  classname,
  styles,
  width,
  options,
  onSearch,
  placeholder,
  loading = false,
  foundContent = true,
  value,
  listHeight,
}: SearchProps) {
  const [selectedValue, setSelectedValue] = useState(value);

  const SearchStyle = {
    borderBottom: '1px solid rgb(209, 13, 116)',
    ...styles,
  };

  const inputStyle = {
    width: `${width}px`, // Convert the width prop to pixels
  };

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const classes = classNames('mb-search', classname);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    // Focus on the input element when the component mounts
    inputRef.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef.current?.focus()]);

  const handleInputChange = (values: string) => {
    onSearch?.(values);
  };

  const handleSelect = (__value: any, option: any) => {
    onSelect?.(option);
  };

  return (
    <div className={classes} style={SearchStyle}>
      <AutoComplete
        listHeight={listHeight}
        popupClassName="search"
        style={inputStyle}
        options={options}
        onSelect={handleSelect}
        onSearch={handleInputChange}
        // defaultValue={selectedValue}
        value={selectedValue}
        placeholder={placeholder}
        bordered={false}
        allowClear
        defaultOpen
        notFoundContent={
          // eslint-disable-next-line no-nested-ternary
          loading ? (
            <img
              style={{ width: 30, padding: 5 }}
              src={LoadingIcon}
              alt="loading icon"
            />
          ) : foundContent ? (
            <span className="p-2">
              <Translate en="No match found" bn="কিছু খুঁজে পাওয়া যায়নি" />
            </span>
          ) : (
            ''
          )
        }
        ref={(input) => {
          // @ts-ignore
          inputRef.current = input;
        }}
      />
    </div>
  );
}

export default memo(Search);
